import { GreenColors } from '@/theme';

export const CONFIRM_OK_TEXT = 'Confirm';
export const CONFIRM_CANCEL_TEXT = 'Cancel';

/** Standard confirm-action color shared by every confirmation modal. */
export const CONFIRM_OK_BUTTON_COLOR = GreenColors[60];
